const citySlider = document.querySelector('.city__slider');

if (citySlider) {
    function myPlugin({swiper, extendParams, on}) {
        extendParams({
            scaleEffect: {
                scale: 0.8,
            },
        });

        function updateSlidesScale() {
            swiper.slides.forEach((slide, index) => {
                if (index === swiper.activeIndex) {
                    slide.style.transform = `scale(1)`;
                } else {
                    slide.style.transform = `scale(${swiper.params.scaleEffect.scale})`;
                    // slide.style.transform = `scale(${swiper.params.scaleEffect.scale})  translateY(14%)`;
                }
            });
        }

        on('init', () => {
            updateSlidesScale();
        });

        on('slideChangeTransitionStart', () => {
            updateSlidesScale();
        });
        on('slideChangeTransitionEnd', () => {
            updateSlidesScale();
        });
    }

    const swiper = new Swiper(citySlider, {
        // modules: [myPlugin],
        watchOverflow: true,
        observer: true,
        resizeObserver: true,
        slidesPerView: "auto",
        spaceBetween: 40,
        loop: true,
        speed: 2000,
        grabCursor: true,
        navigation: {
            nextEl: '.city__slider-button--next',
            prevEl: '.city__slider-button--prev',
        },
        pagination: {
            el: '.city__pagination',
            type: 'fraction'
        },
        // scaleEffect: {
        //     scale:  0.54876,
        // },
        breakpoints: {
            0: {
                spaceBetween: 10,
                initialSlide: 0,
                centeredSlides: true,
            },
            768: {
                spaceBetween: 20,
                initialSlide: 2,
                slidesPerView: "auto",
                centeredSlides: false,
            },
            1326: {
                spaceBetween: 20,
                initialSlide: 3
            },
            1601: {
                spaceBetween: 40,
                initialSlide: 2
            }
        },
    });
}